import requestAction from '../../utils/requestAction'

export const fetchCurrentAccount = (receiptId: string, clientId?: string, params?: string) => {
  return requestAction('CURRENT_ACCOUNT_DETAIL', params)(`currentAccounts/detail?receiptId=${receiptId}${clientId ? '&clientId='+clientId: ''}`, 'GET')
}
